<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                    <v-flex v-bind:key="match['.key']" xs12>
                        <v-card class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ match.description }}
                                       </h3>
                                    <div>{{match.places - match.placesSold}} aantal plaatsen vrij, {{match.placesSold}} plaatsen verkocht</div>
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
            </v-layout>
        </v-container>
        <v-container fluid grid-list-lg v-if="items">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-1"
            >
                <template slot="items" slot-scope="props">
                    <td>
                        <v-edit-dialog
                                :return-value="props.item.totalTickets"
                                lazy
                        > {{ props.item.totalTickets }}
                            <v-text-field
                                    slot="input"
                                    :value="props.item.totalTickets"
                                    @change="(value) => editItem(props.item.unitPrice, value)"
                                    label="Edit"
                                    single-line
                            ></v-text-field>
                        </v-edit-dialog>
                    </td>
                    <td>{{ props.item.originalTotalTickets }}</td>
                    <td>{{ props.item.unitPrice }}</td>
                    <td>{{ props.item.totalPrice }}</td>
                </template>
                <template slot="no-data">
                    Geen data gevonden. <v-btn v-if="hasReport == false" color="primary" @click="generateReport(false)">Rapport maken</v-btn>
                </template>
                <template slot="footer" v-if="report && report.totals">
                    <td>
                        <strong>{{report.totals.totalTickets}}</strong>
                    </td>
                    <td>
                        <strong>{{report.totals.originalTotalTickets}}</strong>
                    </td>
                    <td></td>
                    <td>
                        <strong>{{report.totals.totalPrice}}</strong>
                    </td>
                </template>
            </v-data-table>
            <template>
                <v-btn v-if="hasReport == true" color="primary" @click="() => {generateReport(true)}">Reset</v-btn>
            </template>
        </v-container>
        <v-container fluid grid-list-lg>
            <iframe width="100%" height="600px" :src="reportDocument" frameborder="0"></iframe>
        </v-container>
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import printReport from "../reportPrinter";

export default {
  name: "Report",
  props: {
    id: String
  },
  data() {
    return {
      match: {},
      matchKey: null,
      report: {},
      reportKey: null,
      reportDocument: null,
      dialog: false,
      reportGenerated: false,
      itemToEdit: null,
      isDouble: v => !isNaN(Number(v)),
      headers: [
        { text: "Aantal tickets", value: "totalTickets", sortable: false },
        {
          text: "Origineel aantal tickets",
          value: "originalTotalTickets",
          sortable: false
        },
        {
          text: "Prijs per ticket (€)",
          align: "left",
          sortable: false,
          value: "unitPrice"
        },
        { text: "Totaal (€)", value: "totalPrice", sortable: false }
      ]
    };
  },
  computed: {
    hasReport() {
      return this.reportGenerated;
    },
    items() {
      return this.hasReport ? Object.values(this.report.tickets) : [];
    }
  },
  mounted() {
    this.fetchMatch();
    this.fetchReport();
  },
  methods: {
    fetchMatch: function() {
      db.collection("matches")
        .doc(this.$route.params.id)
        .get()
        .then(match => (this.match = match.data()));
    },
    fetchReport: function() {
      this.setReportGenerated(false);
      db.collection("reports")
        .where("matchKey", "==", this.$route.params.id)
        .limit(1)
        .get()
        .then(reports => {
          reports.forEach(report => {
            if (!this.hasReport) {
              this.report = report.data();
              this.reportKey = report.id;
              this.setReportGenerated(true);
            }
          });
        });
    },
    generateReportPDF: function(report) {
      this.reportDocument = printReport(report).output('datauristring');
    },
    generateReport: function(reset) {
      const report = {
        tickets: {},
        totals: {
          totalTickets: 0,
          originalTotalTickets: 0,
          totalPrice: 0
        }
      };

      db.collection("tickets")
        .where("matchKey", "==", this.$route.params.id)
        .get()
        .then(tickets => {
          // Set report tickets sold
          tickets.forEach(ticket => {
            const ticketData = ticket.data();
            if (!report.tickets[ticketData.price]) {
              report.tickets[ticketData.price] = {
                unitPrice: ticketData.price,
                totalTickets: 0,
                originalTotalTickets: 0,
                totalPrice: 0
              };
            }

            report.tickets[ticketData.price]["totalTickets"] += 1;
            report.tickets[ticketData.price]["originalTotalTickets"] += 1;
            report.tickets[ticketData.price]["totalPrice"] += ticketData.price;
            report.totals.totalTickets += 1;
            report.totals.originalTotalTickets += 1;
            report.totals.totalPrice += ticketData.price;
          });

          // Set report general data
          report.matchKey = this.$route.params.id;
          report.hometeam = this.match.hometeam;
          report.description = this.match.description;
          report.matchDate = this.match.date;
          report.placesSold = this.match.placesSold;
          if (reset) {
            if (confirm("Ben je zeker?")) {
              this.updateReport(this.reportKey, report);
              this.report = report;
            }
          } else {
            this.addReport(report);
          }
        });
    },
    setReportGenerated: function(value) {
      this.reportGenerated = value;
      if (value === true) {
        this.generateReportPDF(this.report);
      }
    },
    addReport: function(report) {
      db.collection("reports").add(report);
      this.fetchReport();
    },
    updateReport: function(reportKey, report) {
      if (reportKey) {
        db.collection("reports")
          .doc(reportKey)
          .set(report);

        this.generateReportPDF(this.report);
      }
    },
    editItem: function(price, newTotalAmount) {
      if (isNaN(Number(newTotalAmount))) {
        alert("Geen geldig totaal");
      } else {
        newTotalAmount = Number(newTotalAmount);
        const updatedReport = this.report;
        const unitPrice = updatedReport.tickets[price].unitPrice;
        const originalTotalTickets = updatedReport.tickets[price].totalTickets;
        const difference = newTotalAmount - originalTotalTickets;
        const priceDifference = difference * unitPrice;
        updatedReport.tickets[price] = {
          ...updatedReport.tickets[price],
          totalTickets: Number(newTotalAmount),
          totalPrice: Number(newTotalAmount) * unitPrice
        };
        updatedReport.totals.totalTickets += difference;
        updatedReport.totals.totalPrice += priceDifference;
        this.updateReport(this.reportKey, updatedReport);
      }
    }
  }
};
</script>
